import {JSX} from "wfr/commons/jsx"
import {EExtType, ENavLanguages, EProductType, JDownloadProductSource, L10nLabels} from "../../commons/api";
import {DownloadProductComponent, seeAlsoProducts, urltree} from "./product";
import {Dict} from "wfr/commons/common"
import {lang} from "../../commons/language-selector";
import {ETileTitle, ProductTile} from "../product-tile";

export {SeeAlsoBox}

const	labels:L10nLabels = {
	[ENavLanguages.fr]: {
		application:"Applications compatibles",
		server:"Serveurs compatibles",
		devtool:"Outils de développement compatibles",
		extension:"Extensions compatibles",
		mod:"Enrichissements du modèle", //pluriel voulu
		gen:"Nouveaux générateurs",  //pluriel voulu
		skin:"Habillages graphiques", //pluriel voulu
	},
	[ENavLanguages.en]: {
		application:"Compatible applications",
		server:"Compatible servers",
		devtool:"Compatible development tools",
		extension:"Compatible extensions",
		mod:"Model enhancements", //pluriel voulu
		gen:"New generators", //pluriel voulu
		skin:"Skins", //pluriel voulu
	}
}


class SeeAlsoBox extends DownloadProductComponent {
	protected seeAlso:{[key in EProductType|EExtType]:Dict<JDownloadProductSource[]>}
	protected labels= labels

	loadData() {
		super.loadData();
		this.seeAlso = {} as {[key in EProductType|EExtType]:Dict<JDownloadProductSource[]>}
		for(let key in seeAlsoProducts){
			//On garde la première version pour indiquer le x.x+ dans la liste des dépendances et la dernière pour le lien
			const productType = seeAlsoProducts[key][0].productType
			const extType = seeAlsoProducts[key][0].extType

			if(extType){
				if(!(extType in this.seeAlso)) this.seeAlso[extType]={}
				this.seeAlso[extType][key] = [seeAlsoProducts[key][0], seeAlsoProducts[key][seeAlsoProducts[key].length-1]]
			}
			else{
				if(!(productType in this.seeAlso)) this.seeAlso[productType]={}
				this.seeAlso[productType][key] = [seeAlsoProducts[key][0], seeAlsoProducts[key][seeAlsoProducts[key].length-1]]
			}
		}
		if(Object.keys(this.seeAlso).length == 0) this.remove()
	}

	rebuild() {
		if(!super.rebuild()) return false;

		for(let key in EProductType){
			if(key in this.seeAlso){
				this.shadowRoot.append(<div class={`seeAlso ${key}`}>
					<div class="head"><span>{this.s(key)}</span></div>
					<ul>
						{Object.keys(this.seeAlso[key as EProductType]).sort().map(productRef=>{return this.buildLi(key as EProductType, productRef)})}
					</ul>
				</div>)
			}
		}
		if(EExtType.mod in this.seeAlso || EExtType.gen in this.seeAlso || EExtType.skin in this.seeAlso){
			this.shadowRoot.append(<div class="seeAlso extension">
				<div class="head"><span>{this.s(EProductType.extension)}</span></div>
				<div class="body">
					{Object.keys(EExtType).map(key=>{
						if(key in this.seeAlso){
							return <div class={key}>
								<div class="headExtType"><span>{this.s(key)}</span></div>
								<ul>
									{Object.keys(this.seeAlso[key as EExtType]).sort().map(productRef => {return this.buildLi(key as EExtType, productRef)})}
								</ul>
							</div>
						} else return null;
					})}
				</div>
			</div>)
		}
	}

	private buildLi(key:EProductType|EExtType, productRef:string){
		const seeAlso = this.seeAlso[key as EProductType][productRef]
		const first = seeAlso[0]
		const last = seeAlso[1]
		return <li class={key}>{new ProductTile(last, urltree, {title:ETileTitle.dep, fromMinorVersion:first.minorVersion, addClassName:"seeAlso"})}</li>
	}

}
customElements.define('seealso-box', SeeAlsoBox)